import gettext from '@sdk/lang/gettext';

import { ComposeConversationHeaderWithPadding } from '@web/conversations/ComposeConversation/ComposeConversationHeader/ComposeConversationHeader';
import UserIcon from '@web/assets/svg/Icons/48/user-blue.svg';

export const CreatePrivateConversationHeader = () => (
  <ComposeConversationHeaderWithPadding>
    <UserIcon />
    <div>
      <ComposeConversationHeaderWithPadding.Title>
        {gettext('New private conversation')}
      </ComposeConversationHeaderWithPadding.Title>
      <ComposeConversationHeaderWithPadding.Subtitle>
        {gettext('Start a private conversation with a coworker.')}
      </ComposeConversationHeaderWithPadding.Subtitle>
    </div>
  </ComposeConversationHeaderWithPadding>
);
